module.exports = Object.freeze({
    NONE: 0,
    EASY: 1,
    INTERMEDIATE: 2,
    ADVANCED: 3,
    OTHER: 4,
});